import { render } from "./Rank.vue?vue&type=template&id=6b1e81a6&scoped=true&ts=true"
import script from "./Rank.vue?vue&type=script&lang=ts"
export * from "./Rank.vue?vue&type=script&lang=ts"

import "./Rank.vue?vue&type=style&index=0&id=6b1e81a6&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1e81a6"]])

export default __exports__